import React, { useState } from 'react';
import { OilIcon } from './OilIcons';

const STEPS = [
  {
    icon: '/oil/tab_imperio.webp',
    title: '1 · CONSTRUA E EXTRAIA',
    text: <>Use suas Black Coins <OilIcon k="black" /> (ganhas nas recargas) para construir a REFINARIA e extrair gotas de petróleo <OilIcon k="drops" />. Quanto maior o nível, mais petróleo jorra!</>,
    accent: 'from-amber-500 to-orange-600',
  },
  {
    icon: '/oil/tab_ranking.webp',
    title: '2 · ENVASE E VENDA',
    text: <>Construa a ENVASADORA, transforme gotas em barris e venda na Bolsa por FOX Dólar <OilIcon k="fox" />. É o FOX Dólar que define o Ranking dos Magnatas e o Jackpot! 👑</>,
    accent: 'from-emerald-500 to-teal-600',
  },
  {
    icon: '/oil/tab_mafia.webp',
    title: '3 · DOMINE A MÁFIA',
    text: 'Na Terra dos Mafiosos você espiona e sabota rivais para ganhar RESPEITO 🔥 e entrar na Lista dos Mais Procurados. Proteja seu império com escudos 🛡️!',
    accent: 'from-rose-600 to-red-800',
  },
];

export default function OilTutorial({ onClose }) {
  const [step, setStep] = useState(0);
  const s = STEPS[step];
  const last = step === STEPS.length - 1;

  const finish = () => {
    localStorage.setItem('oil_tutorial_seen', '1');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 backdrop-blur-sm px-5" data-testid="oil-tutorial">
      <div className="w-full max-w-sm overflow-hidden rounded-3xl border border-amber-800/60 bg-gradient-to-b from-[#151009] to-[#0a0d12] shadow-2xl">
        <div className={`bg-gradient-to-r ${s.accent} px-5 py-2 text-center`}>
          <p className="text-[10px] font-black tracking-[0.3em] text-black/80">BEM-VINDO AO OIL TYCOON</p>
        </div>
        <div className="px-6 py-6 text-center">
          <div className="flex justify-center">
            <img src={s.icon} alt="" data-testid="oil-tutorial-icon"
              className="h-24 w-24 animate-bounce object-contain drop-shadow-[0_0_18px_rgba(255,180,0,0.45)]"
              style={{ animationIterationCount: 3 }} />
          </div>
          <h3 className="mt-3 text-base font-black tracking-wider text-amber-300" data-testid="oil-tutorial-title">{s.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-zinc-300">{s.text}</p>
          <div className="mt-5 flex justify-center gap-1.5">
            {STEPS.map((_, i) => (
              <span key={i} className={`h-1.5 rounded-full transition-all ${i === step ? 'w-6 bg-amber-400' : 'w-1.5 bg-zinc-700'}`} />
            ))}
          </div>
          <button data-testid="oil-tutorial-next"
            onClick={() => (last ? finish() : setStep(step + 1))}
            className={`mt-5 w-full rounded-xl bg-gradient-to-r ${s.accent} py-3 text-sm font-black text-black shadow-lg active:scale-[0.98] transition-transform`}>
            {last ? '⛏️ COMEÇAR MEU IMPÉRIO' : 'PRÓXIMO →'}
          </button>
          {!last && (
            <button onClick={finish} data-testid="oil-tutorial-skip" className="mt-2 text-[11px] font-bold text-zinc-600">
              pular tutorial
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
